"use server";

import { cookies } from "next/headers";
import { revalidatePath } from "next/cache";
import { LOCALE_COOKIE_NAME } from "./locales";
import { getLanguages } from "./index";

export async function setLocaleAction(formData: FormData) {
  const code = String(formData.get("locale") || "en");
  const langs = await getLanguages();
  const valid = langs.some((l) => l.code === code);
  const store = await cookies();
  store.set(LOCALE_COOKIE_NAME, valid ? code : "en", {
    path: "/",
    maxAge: 60 * 60 * 24 * 365,
    sameSite: "lax",
  });
  revalidatePath("/", "layout");
}
